import { format, parseISO } from 'date-fns';
import { BsHospital, BsPersonFill } from 'react-icons/bs';
import SenditLogo from '../../../../assets/images/sendit-logo-mark-color.svg';
import { ActionEnum, BookingRequestUpdate, UserTypeEnum } from '../../../api';
import { BookingHistoryItem } from './BookingHistoryItem';
import { BookingStatusChange } from './BookingStatusChange';

const ActionVerbMap: Record<ActionEnum, string> = {
  [ActionEnum.REQUEST]: 'sent',
  [ActionEnum.CONFIRM]: 'confirmed',
  [ActionEnum.CANCEL]: 'canceled',
  [ActionEnum.RESPOND]: 'responded to',
  [ActionEnum.UPDATE]: 'updated',
};

interface HistoryItemCardProps {
  historyItem: BookingRequestUpdate; // Replace with proper type
}

export const HistoryItemCard = ({ historyItem }: HistoryItemCardProps) => {
  return (
    <div className="ms-xl-4 mb-3 border-bottom pb-1">
      <div className="mb-2">
        <div className="d-flex align-items-center">
          {historyItem.actor?.is_staff ? (
            <img src={SenditLogo} alt="Sendit Logo" className="me-2" style={{ width: '16px' }} />
          ) : historyItem.actor?.user_type === UserTypeEnum.PROVIDER ? (
            <BsPersonFill size={16} className="me-2" />
          ) : (
            <BsHospital size={16} className="me-2" />
          )}
          <b className="text-section-name--dark-brand">
            {historyItem.actor?.provider_degree
              ? `${historyItem.actor.first_name} ${historyItem.actor.last_name} ${historyItem.actor.provider_degree} `
              : `${historyItem.actor.first_name} ${historyItem.actor.last_name} `}
          </b>
          <span className="text-section-name--dark-brand ms-1">
            {ActionVerbMap[historyItem.action]} request
          </span>
        </div>
        <div className="small text-muted ms-4">
          {format(parseISO(historyItem.created_at), 'MMM d, yyyy H:mm z')}
        </div>
      </div>

      <ul className="text-medium">
        {historyItem.changes.status && (
          <li>
            <div>
              <span className="text-muted">Changed status </span>
              <BookingStatusChange
                fromValue={historyItem.changes.status.from_value}
                toValue={historyItem.changes.status.to_value}
              />
            </div>
          </li>
        )}

        {historyItem.changes?.bookings?.map((booking: any) => (
          <BookingHistoryItem key={booking.id} booking={booking} />
        ))}
      </ul>

      {historyItem?.comment && (
        <div className="bg-neutral-200 p-2 ms-2 mb-2 rounded">
          <div className="small text-muted">Comment</div>
          <div className="text-medium">{historyItem.comment}</div>
        </div>
      )}
    </div>
  );
};
